import CAKE from './assets/CAKE.svg'
import COMPUTER from './assets/COMPUTER.svg'
import DESERT_ISLAND from './assets/DESERT_ISLAND.svg'
import GAME from './assets/GAME.svg'
import GIFT from './assets/GIFT.svg'
import HOME from './assets/HOME.svg'
import MONEYBAG from './assets/MONEYBAG.svg'
import PLANE from './assets/PLANE.svg'
import RAINY_DAY from './assets/RAINY_DAY.svg'
import SCHOOL from './assets/SCHOOL.svg'
import SICK from './assets/SICK.svg'
import SILVERWARE from './assets/SILVERWARE.svg'

export const EmojisOld = {
  SILVERWARE: SILVERWARE,
  SCHOOL: SCHOOL,
  SICK: SICK,
  RAINY_DAY: RAINY_DAY,
  HOME: HOME,
  MONEYBAG: MONEYBAG,
  PLANE: PLANE,
  GIFT: GIFT,
  GAME: GAME,
  DESERT_ISLAND: DESERT_ISLAND,
  COMPUTER: COMPUTER,
  CAKE: CAKE,
} as const

export type EmojiNameOld = keyof typeof EmojisOld
